(function () {
  function buildSrcset(url) {
    if (!url) return '';
    return [200, 350, 500, 600, 800]
      .map((w) => `${url.replace(/(\?|&)width=\d+/, '$1width=' + w).replace(/^([^?]+)(\?.*)$/, (_, path, qs) => qs.includes('width=') ? _ : path + '?width=' + w + '&' + qs.slice(1))} ${w}w`)
      .join(', ');
  }

  function buildImageSrcset(url) {
    if (!url) return '';
    // Shopify CDN URLs with ?width=N or without — normalise to ?width=N form
    const base = url.replace(/[?&]width=\d+/, '');
    const sep = base.includes('?') ? '&' : '?';
    return [200, 350, 500, 600, 800]
      .map((w) => `${base}${sep}width=${w} ${w}w`)
      .join(', ');
  }

  const SIZES = '(max-width: 599px) calc(50vw - 20px), (max-width: 999px) calc(33vw - 20px), (max-width: 1199px) calc(25vw - 20px), calc(20vw - 20px)';

  function addToCart(variantId, cfg) {
    const btn = document.querySelector(`[data-lazy-atc="${variantId}"]`);
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');

    const textEl = btn.querySelector('span:first-child');
    const original = textEl.textContent;
    textEl.textContent = 'Adding...';

    const cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((s) => s.id),
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          textEl.textContent = original;
          btn.removeAttribute('aria-disabled');
          return;
        }
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        cart.renderContents(response);
        textEl.textContent = 'Added!';
        setTimeout(() => {
          btn.removeAttribute('aria-disabled');
          textEl.textContent = original;
        }, 1500);
      })
      .catch(() => {
        textEl.textContent = original;
        btn.removeAttribute('aria-disabled');
      });
  }

  function buildSwatchEl(data, type, isActive, cfg) {
    const swatch = document.createElement('product-card-swatch');
    swatch.dataset.type = type;
    swatch.dataset.productId = data.id || '';
    if (data.variant_id) swatch.dataset.variantId = data.variant_id;
    swatch.dataset.productUrl = data.url;
    swatch.dataset.onSale = data.on_sale ? 'true' : 'false';
    swatch.dataset.price = data.price_formatted || '';
    swatch.dataset.compareAtPrice = data.compare_at_price_formatted || '';
    if (data.sample_variant_id) swatch.dataset.sampleVariantId = data.sample_variant_id;
    if (data.badge_text) {
      swatch.dataset.badgeText = data.badge_text;
      if (data.badge_bg) swatch.dataset.badgeBgColour = data.badge_bg;
      if (data.badge_fg) swatch.dataset.badgeFgColour = data.badge_fg;
    }
    swatch.className = 'no-js-hidden';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-card--swatch-button' + (isActive ? ' active' : '');

    const img = document.createElement('img');
    const imgUrl = data.image_url || data.featured_image_url || data.active_swatch_image_url;
    if (imgUrl) {
      img.src = imgUrl;
    }
    img.loading = 'lazy';
    btn.append(img);
    swatch.append(btn);
    return swatch;
  }

  function buildCard(product, cfg, sectionId, index) {
    const isPreorder = product.is_preorder;
    const inStock = product.available && product.variant_available;
    const onSale = product.on_sale;
    const hasLinked = product.linked_products && product.linked_products.length > 0;
    const hasSwatches = product.variant_swatches && product.variant_swatches.length > 0;
    const hasSwatch = hasLinked || hasSwatches;
    const showPrice = cfg.showPrice !== false;

    // <li>
    const li = document.createElement('li');
    li.className = 'product-slider--product-card-container' +
      (cfg.animateReveal ? ' scroll-trigger animate--slide-in' : '');
    if (cfg.animateReveal) {
      li.setAttribute('data-cascade', '');
      li.style.setProperty('--animation-order', index + 1);
    }

    // <product-card>
    const card = document.createElement('product-card');
    card.dataset.originalProductId = product.id;
    card.dataset.originalProductVariantId = product.variant_id;
    card.dataset.hasLinkedProducts = hasLinked;
    card.dataset.hasVariantSwatch = hasSwatches;
    card.dataset.addToCartText = cfg.addToCartText;
    card.dataset.orderSampleText = cfg.orderSampleText;
    card.dataset.soldOutText = cfg.soldOutText;
    card.dataset.available = product.available ? 'true' : 'false';
    li.append(card);

    // <div class="card-wrapper product-card-wrapper">
    const wrapper = document.createElement('div');
    wrapper.className = 'card-wrapper product-card-wrapper' + (hasSwatch ? '' : ' product-card-no-swatch');
    card.append(wrapper);

    const hasMedia = !!product.featured_image_url || cfg.hasGlobalDefaultImage;
    const cardDiv = document.createElement('div');
    cardDiv.className = [
      'card',
      `card--${cfg.cardStyle}`,
      hasMedia ? 'card--media' : 'card--text',
      cfg.cardStyle === 'card' ? 'gradient' : '',
    ].filter(Boolean).join(' ');
    cardDiv.style.setProperty('--ratio-percent', '100%');
    wrapper.append(cardDiv);

    // Image container
    const imgContainer = document.createElement('div');
    imgContainer.className = 'product-card--image-container';
    cardDiv.append(imgContainer);

    const imgLinkWrapper = document.createElement('div');
    imgContainer.append(imgLinkWrapper);

    const imgLink = document.createElement('a');
    imgLink.href = product.url;
    imgLink.id = `CardLink-${sectionId}-${product.id}`;
    imgLinkWrapper.append(imgLink);

    const imagesDiv = document.createElement('div');
    imagesDiv.className = 'product-card--images transparent-scrollbar' + (cfg.oneImageMobile ? ' one-image-mobile' : '');
    imagesDiv.setAttribute('data-product-card-images', '');
    imgLink.append(imagesDiv);

    if (product.featured_image_url) {
      const img = document.createElement('img');
      img.src = product.featured_image_url;
      img.srcset = buildImageSrcset(product.featured_image_url);
      img.sizes = SIZES;
      img.loading = 'lazy';
      img.className = 'product-card--image';
      img.setAttribute('data-id', product.id);
      imagesDiv.append(img);
    } else if (cfg.hasGlobalDefaultImage && cfg.globalDefaultImageUrl) {
      const img = document.createElement('img');
      img.src = cfg.globalDefaultImageUrl;
      img.loading = 'lazy';
      img.className = 'product-card--image';
      imagesDiv.append(img);
    }

    // Button container
    const btnContainer = document.createElement('div');
    btnContainer.className = 'product-card--button-container';
    imgContainer.append(btnContainer);

    if (cfg.enableAddToCart === 'all' || product.sample_variant_id) {
      const quickAdd = document.createElement('div');
      quickAdd.className = 'quick-add no-js-hidden' + (product.sample_variant_id ? ' has-sample' : '');
      btnContainer.append(quickAdd);

      const variantIdToAdd = product.sample_variant_id || product.variant_id;
      let btnText;
      if (product.sample_variant_id) {
        btnText = cfg.orderSampleText;
      } else if (!inStock) {
        btnText = cfg.soldOutNotifyText;
      } else if (isPreorder) {
        btnText = cfg.preOrderText;
      } else {
        btnText = cfg.addToCartText;
      }

      const atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'quick-add__submit add-to-cart button button--full-width';
      atcBtn.setAttribute('aria-haspopup', 'dialog');
      atcBtn.setAttribute('aria-live', 'polite');
      atcBtn.setAttribute('data-sold-out-message', 'true');
      atcBtn.setAttribute('data-lazy-atc', variantIdToAdd);
      atcBtn.innerHTML = `<span>${btnText}</span><span class="sold-out-message hidden">${cfg.soldOutText}</span>`;
      atcBtn.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart(variantIdToAdd, cfg);
      });
      quickAdd.append(atcBtn);
    }

    if (cfg.showWishlist) {
      const wishlistWrap = document.createElement('div');
      wishlistWrap.className = 'has_wishlist';

      const wishlistEl = document.createElement('add-to-wishlist-button');
      wishlistEl.dataset.variantId = product.variant_id;
      wishlistEl.dataset.productId = product.id;
      wishlistEl.dataset.productHandle = product.url.split('/').pop();
      wishlistEl.dataset.wishlistPage = '0';
      wishlistEl.dataset.customerId = cfg.customerId || '';
      wishlistEl.dataset.onSale = onSale ? 'true' : 'false';

      const wishlistBtn = document.createElement('button');
      wishlistBtn.className = 'button product-card__add-to-wishlist-button button--full-width';
      wishlistBtn.type = 'button';
      const wishlistSpan = document.createElement('span');
      wishlistSpan.className = 'add-to-wishlist-button__text';
      wishlistSpan.textContent = cfg.addToWishlistText || 'Add to Wishlist';
      wishlistBtn.append(wishlistSpan);
      wishlistEl.append(wishlistBtn);
      wishlistWrap.append(wishlistEl);
      btnContainer.append(wishlistWrap);
    }

    // Department badge
    if (product.department_icon_url) {
      const deptContainer = document.createElement('div');
      deptContainer.className = 'card__department_icon_container badge_layout_stacked';
      const deptIcon = document.createElement('img');
      deptIcon.src = product.department_icon_url;
      deptIcon.alt = product.department_title || '';
      deptIcon.className = 'department_icon';
      deptIcon.loading = 'lazy';
      deptContainer.append(deptIcon);
      imgContainer.append(deptContainer);
    }

    // Card content
    const content = document.createElement('div');
    content.className = 'card__content';
    cardDiv.append(content);

    // Swatch container
    if (hasSwatch) {
      const swatchContainer = document.createElement('div');
      swatchContainer.className = 'product-card--swatch-container';

      if (hasLinked) {
        // Active swatch = current product
        const activeSwatch = buildSwatchEl(
          {
            id: product.id,
            url: product.url,
            variant_id: product.variant_id,
            on_sale: onSale,
            price_formatted: product.price_formatted,
            compare_at_price_formatted: product.compare_at_price_formatted,
            sample_variant_id: product.sample_variant_id,
            badge_text: product.badge_text,
            badge_bg: product.badge_bg,
            badge_fg: product.badge_fg,
            active_swatch_image_url: product.active_swatch_image_url,
          },
          'linked',
          true,
          cfg,
        );
        swatchContainer.append(activeSwatch);
        product.linked_products.forEach((lp) => {
          swatchContainer.append(buildSwatchEl(lp, 'linked', false, cfg));
        });
      } else if (hasSwatches) {
        // Active swatch = current variant
        const activeSwatch = buildSwatchEl(
          {
            id: product.id,
            url: product.url,
            variant_id: product.variant_id,
            on_sale: onSale,
            price_formatted: product.price_formatted,
            compare_at_price_formatted: product.compare_at_price_formatted,
            sample_variant_id: product.sample_variant_id,
            badge_text: product.badge_text,
            badge_bg: product.badge_bg,
            badge_fg: product.badge_fg,
            active_swatch_image_url: product.active_swatch_image_url,
          },
          'variant',
          true,
          cfg,
        );
        swatchContainer.append(activeSwatch);
        product.variant_swatches.forEach((sv) => {
          const swatchData = {
            id: product.id,
            url: sv.url,
            variant_id: sv.variant_id,
            on_sale: sv.on_sale,
            price_formatted: sv.price_formatted,
            compare_at_price_formatted: sv.compare_at_price_formatted,
            sample_variant_id: sv.sample_variant_id,
            badge_text: sv.badge_text,
            badge_bg: sv.badge_bg,
            badge_fg: sv.badge_fg,
            image_url: sv.image_url,
          };
          swatchContainer.append(buildSwatchEl(swatchData, 'variant', false, cfg));
        });
      }

      content.append(swatchContainer);
    }

    // Title
    const heading = document.createElement('h3');
    heading.className = 'text-body card__heading underline-links-hover';
    heading.id = `title-${sectionId}-${product.id}`;
    const titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.id = `CardLink-${sectionId}-${product.id}`;
    titleLink.className = 'full-unstyled-link';
    titleLink.setAttribute('aria-labelledby', `CardLink-${sectionId}-${product.id} Badge-${sectionId}-${product.id}`);
    titleLink.textContent = product.title;
    heading.append(titleLink);
    content.append(heading);

    // Artist
    if (product.artist) {
      const artist = document.createElement('h4');
      artist.className = 'text-body card__artist';
      artist.textContent = product.artist;
      content.append(artist);
    }

    // Price block
    if (showPrice) {
      const priceInfo = document.createElement('div');
      priceInfo.className = 'card-price-information';

      const typeSpan = document.createElement('span');
      typeSpan.textContent = product.type || '';
      priceInfo.append(typeSpan);

      // Sale badge (mirrors sale-badge.liquid)
      if (onSale && inStock && product.sale_percentage >= (cfg.saleBadgeThreshold || 5)) {
        const badge = document.createElement('span');
        badge.className = 'discount_percentage';
        badge.style.color = `rgb(var(${cfg.saleBadgeFg}))`;
        badge.style.backgroundColor = `rgb(var(${cfg.saleBadgeBg}))`;
        badge.textContent = `${cfg.saleBadgeText || 'Save '}${product.sale_percentage}%`;
        priceInfo.append(badge);
      }

      // Price
      const priceWrapper = document.createElement('div');
      priceWrapper.className = onSale ? 'price price--on-sale' : 'price';
      const priceContainer = document.createElement('div');
      priceContainer.className = 'price__container';
      priceWrapper.append(priceContainer);

      // Regular price row (shown when not on sale)
      const priceRegular = document.createElement('div');
      priceRegular.className = 'price__regular';
      const regularLabel = document.createElement('span');
      regularLabel.className = 'visually-hidden visually-hidden--inline';
      regularLabel.textContent = 'Regular price';
      priceRegular.append(regularLabel);
      const regularValue = document.createElement('span');
      regularValue.className = 'price-item price-item--regular';
      regularValue.textContent = product.price_formatted;
      priceRegular.append(regularValue);
      priceContainer.append(priceRegular);

      // Sale price row (shown when on sale)
      const priceSale = document.createElement('div');
      priceSale.className = 'price__sale';
      const saleRegularLabel = document.createElement('span');
      saleRegularLabel.className = 'visually-hidden visually-hidden--inline';
      saleRegularLabel.textContent = 'Regular price';
      priceSale.append(saleRegularLabel);
      const compareWrap = document.createElement('span');
      const compareEl = document.createElement('s');
      compareEl.className = 'price-item price-item--regular';
      compareEl.textContent = product.compare_at_price_formatted;
      compareWrap.append(compareEl);
      priceSale.append(compareWrap);
      const salePriceLabel = document.createElement('span');
      salePriceLabel.className = 'visually-hidden visually-hidden--inline';
      salePriceLabel.textContent = 'Sale price';
      priceSale.append(salePriceLabel);
      const saleValue = document.createElement('span');
      saleValue.className = 'price-item price-item--sale price-item--last';
      saleValue.textContent = product.price_formatted;
      priceSale.append(saleValue);
      priceContainer.append(priceSale);

      priceInfo.append(priceWrapper);
      content.append(priceInfo);
    }

    // Product badge (mirrors product-badges.liquid)
    if (!product.available && cfg.showSoldOutBadge) {
      const soldOut = document.createElement('span');
      soldOut.className = 'badge badge-sold-out price__badge-sold-out badge-format-right-small';
      soldOut.textContent = product.stock_due_date
        ? (product.stock_due_date === 'Due Soon' ? 'Due Soon' : `Due on ${product.stock_due_date}`)
        : cfg.soldOutText;
      cardDiv.append(soldOut);
    } else if (product.available) {
      // Custom badge slot — filled client-side by product-badge-loader.js
      const badgeSlot = document.createElement('span');
      badgeSlot.className = 'product-badge-slot';
      badgeSlot.setAttribute('data-product-badge', '');
      badgeSlot.setAttribute('data-badge-format', 'right-small');
      badgeSlot.setAttribute('data-product-tags', (product.tags || []).join(','));
      cardDiv.append(badgeSlot);
    }

    return li;
  }

  window.renderLazyProducts = function (sectionEl) {
    const script = sectionEl.querySelector('script[data-lazy-products]');
    if (!script) return;

    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      console.warn('[lazy-renderer] Failed to parse product JSON', e);
      return;
    }

    const list = sectionEl.querySelector('[data-product-carousel]');
    if (!list) return;

    const { config, products } = data;
    products.forEach((product, index) => {
      list.append(buildCard(product, config, config.sectionId, index));
    });

    script.remove();
    sectionEl.removeAttribute('style');
    document.dispatchEvent(new CustomEvent('product-badges:refresh'));
  };
})();